import '@/styles/app'
import 'virtual:mdi-icons-round.css'
import 'virtual:tmi-icons.css'
import { Quasar } from 'quasar'
import SubscribeContainer from '@widgets/subscribe/components/SubscribeContainer.vue'
import i18n from '@widgets/shared/locales/i18n'
import sentryMonitoringService from '@widgets/shared/services/monitoring/sentryMonitoringService'
import { createApp } from '@/composition/vue/compositionApi'
import quasarOptions from '@/quasarOptions'
import { isSentryOn } from '@/utils/system'
import { safeHtmlDirective } from '@/directives/safe-html/safe-html.directive'

const app = createApp(SubscribeContainer)
app.use(Quasar, quasarOptions)
app.use(i18n)
app.directive('safe-html', safeHtmlDirective)

if (isSentryOn()) {
  sentryMonitoringService.init('widget-subscribe')
}

app.mount('#app')
